import { entityStore, sirenActions } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-action';

class BillingBinProperties extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      table {
        width: 100%;
      }
    `];
  }

  render() {
    if (!this.entity || !this.entity.getAction('create-or-update-billing-property')) {
      return html``;
    }
    const properties = this.entity.entities;
    const propertyMap = new Map(properties.map(property => [property.properties.key, property]));

    return html`
      <table>
        ${this._renderProperty({ key: 'billingEnabled', entity: propertyMap.get('billingEnabled'), offValue: false, label: 'Billing enabled' })}
        ${this._renderProperty({ key: 'billingSlaPercent', entity: propertyMap.get('billingSlaPercent'), offValue: 0, label: 'SLA enforced' })}
      </table>
    `;
  }

  _renderProperty({ key, entity, offValue, label }) {
    const overrideSet = entity?.properties.value === offValue;

    return html`
      <tr>
        <td>${label}</td>
        <td>${!overrideSet}</td>
        <td>
          ${renderIf(overrideSet, html`<button class="button button--contained" @click="${() => this._clearDisable(entity)}">Enable</button>`)}
          ${renderIf(!overrideSet, html`<button class="button button--outlinedError" @click="${() => this._doDisable({ key, value: offValue })}">Disable</button>`)}
        </td>
      </tr>
    `;
  }

  async _doDisable({ key, value }) {
    await sirenActions.submitAction(this.entity.getAction('create-or-update-billing-property'), { key, value });
    this._onChange();
  }

  async _clearDisable(entity) {
    await sirenActions.submitAction(entity.getAction('delete-billing-property'));
    this._onChange();
  }

  _onChange() {
    entityStore.invalidateHref(this.href);
  }
}

window.customElements.define('billing-bin-properties', BillingBinProperties);
